const resources = {
    endingIn: 'ending in',
    cardNumber: 'Card Number',
    mm: 'MM',
    yy: 'YY',
    cvc: 'Security Code',
    moreInfoPopover: 'More info about CVV',
    firstName: 'First Name',
    lastName: 'Last Name',
    billingAddress: 'Billing Address',
    useMyAddressRadio: 'Use my shipping address',
    useDiffAddressRadio: 'Use a different address',
    saveCardCheckboxText: 'Save this card for future purchases',
    makeDefaultCheckboxText: 'Set as my default card',
    editCardTitle: 'Edit a Credit or Debit Card',
    addNewCardTitle: 'Add a Credit or Debit Card',
    cancelButton: 'Cancel',
    saveContinueButton: 'Save & Continue',
    debitCardDisclaimer: 'Visa and Mastercard debit cards only',
    expirationDate: 'Expiration Date',
    enterValidCardNumber: 'Please enter a valid card number.',
    useThisCard: 'Use This Card',
    cvv: 'CVV / CVC'
};

export default function getResource(label) {
    return resources[label];
}
